import { render, staticRenderFns } from "./ParticipantsDialog.vue?vue&type=template&id=7bb80786&scoped=true"
import script from "./ParticipantsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantsDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ParticipantsDialog.vue?vue&type=style&index=0&id=7bb80786&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb80786",
  null
  
)

export default component.exports